import mitt from 'mitt'

export const event = mitt()
